/*
 * File: ResponsiveMasonry.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 2:02 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveMasonry as ResponsiveMasonryCore } from 'react-responsive-masonry';

// Constants
import { masonryThreeBreakpoints } from '../../styles/constants';

// Styles
import * as S from './ResponsiveMasonry.styles';


/**
 * Component
 */

export const ResponsiveMasonry = ({
	className, children, style, defaultBreakpoint, breakpoints
}) => {

	// Create state handlers
	const [isRendered, setIsRendered] = useState(false);

	// Handle actions on component load
	useEffect(() => {

		// Set is rendered
		setIsRendered(true);

	}, []);

	// Render Masonry
	const RenderedMasonry = useCallback((breakpts) => (
		<ResponsiveMasonryCore columnsCountBreakPoints={breakpts} className={className} style={style}>
			{children}
		</ResponsiveMasonryCore>
	), [children, className, style]);

	// Render component
	return (
		<>
			<S.PrimaryContainer className={className} $isRendered={isRendered}>
				{RenderedMasonry(breakpoints)}
			</S.PrimaryContainer>
			{!isRendered && (
				<S.DesktopContainer className={className}>
					{RenderedMasonry({ 0: defaultBreakpoint })}
				</S.DesktopContainer>
			)}
		</>
	);
};


/**
 * Configuration
 */

ResponsiveMasonry.displayName = 'ResponsiveMasonry';
ResponsiveMasonry.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	style: PropTypes.shape(),
	defaultBreakpoint: PropTypes.number,
	breakpoints: PropTypes.shape()
};
ResponsiveMasonry.defaultProps = {
	className: null,
	children: null,
	style: {},
	defaultBreakpoint: 3,
	breakpoints: masonryThreeBreakpoints
};
